import { createContext, useContext } from 'react';
export const DetailsPageContext = /*#__PURE__*/createContext({
  appContext: 'app',
  iconUrl: '',
  listingId: 0,
  name: '',
  productType: 'APP',
  published: true,
  runLeadGen: () => {},
  trackInteraction: () => {},
  trackInstall: () => {},
  userInfo: {},
  isEmbedded: false
});
export const useDetailsPageContext = () => {
  const context = useContext(DetailsPageContext);
  if (!context) {
    throw new Error('useDetailsPageContext must be used within a DetailsPageContext.Provider');
  }
  return context;
};